"use strict";
/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * ČVS - API
 * OpenAPI spec version: 1.1.529
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestFlowResponseConfirmationType = void 0;
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.RequestFlowResponseConfirmationType = {
    print: 'print',
    player: 'player',
    club: 'club',
    home_club: 'home_club',
    federation: 'federation',
    rmk: 'rmk',
    stk: 'stk',
    team: 'team',
    cancel: 'cancel',
    severance: 'severance',
    competition_manager: 'competition_manager',
    beach_type_admin: 'beach_type_admin',
    beach_player: 'beach_player',
};
